import { cn } from "~/utils/helpers"

export default function HoverCardRowWrapper({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cn("bg-base", className)}>{children}</div>
}
